import { Button, Calendar, Icon, Popover, PopoverContent, PopoverTrigger } from "@/shared/components";
import { cn, formatDateRelative } from "@/shared/utils";
import { useState } from "react";
import { OnSelectHandler } from "@daypicker/react";

interface DatePickerProps {
    date?: Date;
    onSelect?: OnSelectHandler<Date>;
    disabled?: boolean;
    className?: string;
    closeOnSelect?: boolean;
}

export function DatePicker({ date, onSelect, disabled = false, className, closeOnSelect = true }: DatePickerProps) {
    const [calendarDialogOpen, setCalendarDialogOpen] = useState(false);

    const handleSelect: OnSelectHandler<Date> = (selected, triggerDate, modifiers, e) => {
        onSelect?.(selected, triggerDate, modifiers, e);
        if (closeOnSelect) {
            setCalendarDialogOpen(false);
        }
    };

    return (
        <Popover open={calendarDialogOpen} onOpenChange={setCalendarDialogOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="secondary"
                    className={cn(
                        "placeholder:text-content-placeholder border-input-default bg-input md:text-m text-m flex w-full min-w-0 rounded-md border px-2.75 py-1.75 shadow-xs transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                        "focus-visible:outline-focus focus-visible:border-transparent focus-visible:outline-2",
                        "border-input-default text-content-default min-w-37 justify-between text-left font-normal",
                        className
                    )}
                    disabled={disabled}
                >
                    {date ? formatDateRelative(date) : <span>Kies een datum</span>}
                    <Icon name="calendar" size="xs" className="text-content-interactive-default ml-2" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar required mode="single" selected={date} onSelect={handleSelect} autoFocus />
            </PopoverContent>
        </Popover>
    );
}
